import Summary from './Summary.styled';

export default Summary;
